var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('List',{attrs:{"headers":_vm.headers,"formview":_vm.formview,"table":_vm.table,"default_limit":'',"default_sort":'company',"default_sort_typ":'ASC',"extension":'(isCustomer= \'1\')',"export_csv":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }